import {
  CONSTANTS_DATA,
  getColumns,
} from "../../../CreateJobView/MaterialTruckDetails/MaterialDetails/constants";
import ConditionalRender from "../../../../../reusable-components/ConditionalRender";
import { Table } from "antd";
import styles from "./ViewMaterial.module.scss";

const ViewMaterial = ({ materialTruckList, handleOpenBidTool }) => {
  const data = materialTruckList
    ?.filter((item) => item?.type === "material")
    ?.map((item: MaterialTruck) => ({
      vendorName: item?.vendor,
      materialName: item?.materialName,
      materialCost: item?.materialCost,
      materialQuantity: item?.materialQuantity,
      materialQuantityUnitType: item?.materialQuantityUnitType,
      materialPrice: item?.materialPrice,
      truckingCost: item?.truckingCost,
      truckingPrice: item?.truckingPrice,
      truckType: item?.truckType,
      materialCostType: item?.materialCostType,
      materialPriceType: item?.materialPriceType,
      truckingCostType: item?.truckingCostType,
      truckingPriceType: item?.truckingPriceType,
      landedCost: item?.landedCost,
      landedCostType: item?.landedCostType,
      landedPrice: item?.landedPrice,
      landedPriceType: item?.landedPriceType,
      isBlocked: item?.isBlocked,
    }));
  const columns = getColumns({ handleOpenBidTool });
  return (
    <ConditionalRender
      visible={materialTruckList?.length}
      fallback={
        <div className={styles.MaterialDetailsContainer}>
          <h1>{CONSTANTS_DATA.NO_DATA}</h1>
        </div>
      }
    >
      <Table columns={columns} dataSource={data} />
    </ConditionalRender>
  );
};

export default ViewMaterial;
